angular.module('salesPath2')
  .controller('applicationBlockedModalCtrl', ['$scope', '$sce', '$filter', 'RESOURCES', 'apkErrorsHelper', '$window',
    function($scope, $sce, $filter, RESOURCES, apkErrorsHelper, $window) {
      var content = $filter('translate')('sp2.modal.packageBlockedInfoMsg');
      $scope.message = $sce.trustAsHtml(content.replace(/(?:\r\n|\r|\n)/g, '<br />').replace('{APP}', RESOURCES.APP_FULLNAME));

      /**
      * init
      */
      $scope.init = function() {        
        $scope.fireListeners();
      };

      /**
       * Odpalenie watchy
       */
      $scope.fireListeners = function() {
        // continue
        $scope.$on('iHestiaCommonModalOkBtnClicked.applicationBlockedModal', function() {
          $window.open(apkErrorsHelper.portalUrl, '_self');
        });
      };

      $scope.init();

    }
  ]);
